import React, { FC, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as accountActions, selectors as accountSelectors } from "@containers/Account/store";
import { CheckoutData, PayPerLeadSubscription } from "@containers/PayPerLead/interface";
import { showNotification } from "@shared/store/actions";

import { CheckoutRow } from "./CheckoutRow";
import { CheckoutRowTotal } from "./CheckoutRowTotal";
import { Quote } from "./Quote";

import "./CheckoutDetails.scss";

export interface CheckoutDetailsProps {
  subscription: PayPerLeadSubscription;
  checkoutData: CheckoutData;
  useQuote?: boolean;
}

export const CheckoutDetails: FC<CheckoutDetailsProps> = ({ subscription, checkoutData, useQuote }) => {
  const showNotificationRef = useRef(false);

  const dispatch = useDispatch();
  const account = useSelector(accountSelectors.getActiveAccount());
  const hasCardPaymentMethod = useSelector(accountSelectors.selectCardPaymentMethodExistence());

  useEffect(() => {
    if (account?.id && !hasCardPaymentMethod) {
      dispatch(accountActions.checkPaymentMethodExistence.request({}));
    }
  }, [dispatch, account, hasCardPaymentMethod]);

  useEffect(() => {
    if (!showNotificationRef.current) {
      showNotificationRef.current = hasCardPaymentMethod === false;
    }

    if (showNotificationRef.current && hasCardPaymentMethod) {
      dispatch(
        showNotification({
          appearance: "success",
          message: "Your card has been added",
        }),
      );
    }
  }, [dispatch, hasCardPaymentMethod]);

  return (
    <>
      {checkoutData.rows.map((row, index) => (
        <CheckoutRow key={index} item={row} />
      ))}

      {useQuote && subscription.id && subscription.quote ? (
        <Quote id={subscription.id} data={subscription.quote} coupon={subscription.coupon} />
      ) : (
        <CheckoutRowTotal item={checkoutData.total} serverPrice={subscription.price} />
      )}
    </>
  );
};
